import PropTypes from "prop-types";
import { useEffect } from "react";
import { Spinner } from "reactstrap";

const Spinners = ({ setLoading }) => {
  useEffect(() => {
    if (setLoading && typeof setLoading === "function") {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [setLoading]);

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100%", minHeight: "100px" }}
    >
      <Spinner color="primary" />
    </div>
  );
};

export default Spinners;

Spinners.propTypes = {
  setLoading: PropTypes.func,
};
